import { render, staticRenderFns } from "./batchPrint.vue?vue&type=template&id=6f8bba98&scoped=true&"
import script from "./batchPrint.vue?vue&type=script&lang=js&"
export * from "./batchPrint.vue?vue&type=script&lang=js&"
import style0 from "./batchPrint.vue?vue&type=style&index=0&id=6f8bba98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8bba98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f8bba98')) {
      api.createRecord('6f8bba98', component.options)
    } else {
      api.reload('6f8bba98', component.options)
    }
    module.hot.accept("./batchPrint.vue?vue&type=template&id=6f8bba98&scoped=true&", function () {
      api.rerender('6f8bba98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/maintainCustomer/batchPrint.vue"
export default component.exports